const maxVolume = 0.95;
const maxVolumeSteps = 100;

export function modelToUiControls(model, hasValidAudio) {
  const volume = {};
  volume.narration = Math.round((model.narration / maxVolume) * maxVolumeSteps);
  volume.video = hasValidAudio
    ? Math.round((model.video / maxVolume) * maxVolumeSteps)
    : 0;
  volume.bgMusic = Math.round((model.bgMusic / maxVolume) * maxVolumeSteps);
  volume.overlayTracks = 0;
  return volume;
}

export function uiControlsToModel(fromUi) {
  const convertFiled = (field) => {
    if (_.isNumber(fromUi[field])) {
      if (fromUi[field] > 0) {
        return app.sfp(maxVolume * (fromUi[field] / maxVolumeSteps));
      }
      return 0;
    }
    return null;
  };

  const narration = convertFiled('narration');
  const video = convertFiled('video');
  const bgMusic = convertFiled('bgMusic');

  return {
    narration,
    video,
    bgMusic,
    overlayTracks: 0,
  };
}
